module.exports = __webpack_public_path__ + "static/media/GroundingTechniques.323f35e3.png";